import React from 'react';
import { IconPlus } from '../../asset';

const ButtonAddWithIcon = ({ buttonName, className, ...rest  }) => {
  return (
    <>
      <div 
        className= {` bg-red-100 rounded-md flex justify-center items-center px-2 cursor-pointer ${className}`}
        { ...rest }
      >
        <p className='text-white-100 flex items-center'>
          <img src={IconPlus} alt="icon-plus" />
          <span className=' pl-1 text-xl font-semibold font-sans'> { buttonName } </span>
        </p>
      </div>
    </>
  );
}

export default ButtonAddWithIcon;